export const hideLinks = ['/access-manage', '/handbooks'];
